module.exports = __webpack_public_path__ + "img/material-green-800.9934dd2f.jpg";